import {combineReducers} from 'redux'
import types from 'actions/types'
import Immutable from 'seamless-immutable'
import {reorderListByIndex} from 'helpers/general/lists'
import {get, isEmpty, isNil, unionBy} from 'lodash'
import {sortByKey} from 'helpers/sorting'

export const updateJobCard = (jobCards, updatedJobCard) => {
  if (Array.isArray(updatedJobCard))
    updatedJobCard = updatedJobCard[0]

  let updatedJobCards = jobCards.map(jobCard =>
      jobCard.id === updatedJobCard.id
          ? updatedJobCard
          : jobCard
  )

  const curJobCard = jobCards.find(jobCard => jobCard.id === updatedJobCard.id)
  const changingOrder = !isNil(curJobCard) && (curJobCard.sortOrder !== updatedJobCard.sortOrder)
  const changingDepartment = !isNil(curJobCard) && (curJobCard.departmentId !== updatedJobCard.departmentId)
  const changingWorkCentre = !isNil(curJobCard) && (curJobCard.workCentreId !== updatedJobCard.workCentreId)

  if (changingOrder || changingDepartment || changingWorkCentre) {

    updatedJobCards = updatedJobCards.filter(jobCard => jobCard.id !== updatedJobCard.id)
    const groupJobCards = [
      ...updatedJobCards.filter(jobCard => (
          jobCard.departmentId === updatedJobCard.departmentId &&
          jobCard.workCentreId === updatedJobCard.workCentreId
      )),
      updatedJobCard,
    ]

    const reorderedGroupJobCards = reorderListByIndex(
        groupJobCards,
        groupJobCards.length - 1,
        updatedJobCard.sortOrder,
        'sortOrder'
    )

    updatedJobCards = unionBy(reorderedGroupJobCards, updatedJobCards, 'id')
  }

  return mergeOrder(updatedJobCards, get(updatedJobCard, 'order', null))
}

export const mergeOrder = (jobCards, order) => {
  if (isNil(order)) {
    return jobCards
  }

  return jobCards.map(jobCard => {
    return jobCard.order.id === order.id
        ? {
          ...jobCard,
          order,
        }
        : jobCard
  })
}

export const mergeOrders = (jobCards, orders) =>
    jobCards.map(jobCard => {
      const order = orders.find(order => order.id === jobCard.order.id)
      return !isNil(order)
          ? {
            ...jobCard,
            order,
          }
          : jobCard
    })

export const mergeOrderItemQuantity = (jobCards, order) => {
  const orderItems = get(order, 'orderitems', [])
  if (isNil(order) || isEmpty(orderItems)) {
    return jobCards
  }
  return jobCards.map(jobCard => {
    const jobCardItemId = get(jobCard, 'orderItem.id', null)
    if (isNil(jobCardItemId)) {
      return jobCard
    }
    const matchingOrderItem = orderItems.find(orderItem => get(orderItem, 'id', null) === jobCardItemId)
    return isNil(matchingOrderItem)
        ? jobCard
        : {
          ...jobCard,
          orderItem: {
            ...jobCard.orderItem,
            quantity: matchingOrderItem.quantity,
          },
        }
  })
}

const sortJobCards = (jobCards) => {
  return jobCards.sort((a, b) =>
      sortByKey(a, b, 'sortOrder')
  )
}

export const data = (state = [], action) => {
  switch (action.type) {
    case types.PRODUCTION_LOAD_JOB_CARDS_ATTEMPT:
      return state

    case types.PRODUCTION_LOAD_JOB_CARDS_SUCCESS:
      return action.data

    case types.PRODUCTION_ADD_JOB_CARD_SUCCESS:
      return sortJobCards(mergeOrder(state.concat(action.data.result), action.data.result.order))

    case types.PRODUCTION_ADD_JOB_CARDS_SUCCESS:
      return sortJobCards(mergeOrders(
          unionBy(action.data.result, state, 'id'),
          action.data.result.map(jobCard => jobCard.order)
      ))

    case types.QUOTING_QUOTE_UPDATE_ORDER:
      return mergeOrder(state, action.order)

      // Note: an optimistic update after a drag/drop
      // operation is important for visual consistency
    case types.PRODUCTION_UPDATE_JOB_CARD_ATTEMPT:
      return sortJobCards(updateJobCard(state, action.jobCard))

      // Note: server-side update is also required in
      // case a change was made by another user
    case types.PRODUCTION_UPDATE_JOB_CARD_SUCCESS:
      return sortJobCards(updateJobCard(state, action.data.result))

    case types.QUOTING_QUOTE_SAVE_RECEIVED:
      const updatedJobCards = sortJobCards(mergeOrder(state, action.data.result))
      return sortJobCards(mergeOrderItemQuantity(updatedJobCards, action.data.result))

    default:
      return state
  }
}

export const loading = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.PRODUCTION_LOAD_JOB_CARDS_ATTEMPT:
      return true
    case types.PRODUCTION_LOAD_JOB_CARDS_SUCCESS:
    case types.PRODUCTION_LOAD_JOB_CARDS_FAILURE:
      return false
    default:
      return state
  }
}

export const observing = (state = false, action) => {
  switch (action.type) {
    case types.OBSERVE_JOB_CARDS:
      return true
    case types.DEOBSERVE_JOB_CARDS:
      return false
    default:
      return state
  }
}

export default combineReducers({
  data,
  loading,
  observing,
})
